import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl';
import { connect } from 'react-redux';
import modal from 'decorators/Modal/Modal';
import { ApiError } from 'components/Errors/ApiError';
import { purchaseClassBundle } from 'redux/saga/entities/bound';
import { ec } from 'helpers/multitrack';
import { purchaseAddOn } from './bundles.saga';
import { messages } from './bundles.messages';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    purchaseError: purchaseClassBundle.error(state),
    purchaseLoading: purchaseClassBundle.loading(state)
  };
};
export var mapDispatchToProps = {
  purchaseAddOn: purchaseAddOn
};
var BUNDLE_PURCHASE_REQUEST_ERR_CODE = 5371; // Generic bundle error. Ex: bundles service can't reach Stripe API

var BUNDLE_PURCHASE_CARD_ERR_CODE = 5372; // Raised when Stripe bounces a purchase

export var ClassBundleModalUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClassBundleModalUnwrapped, _React$Component);

  function ClassBundleModalUnwrapped(props) {
    var _this;

    _classCallCheck(this, ClassBundleModalUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClassBundleModalUnwrapped).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ClassBundleModalUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.trackEventCollector('Manage Add Ons - Review Selection');
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          purchaseLoading = _this$props.purchaseLoading,
          localPurchaseAddOn = _this$props.purchaseAddOn,
          versionedBundleId = _this$props.versionedBundleId; // Ensures only one submission is in flight. ie. multiple clicks don't result in multiple form submissions

      if (!purchaseLoading) {
        this.trackEventCollector('Manage Add Ons - Complete');
        localPurchaseAddOn({
          bundleId: versionedBundleId,
          successMessage: messages.addCreditsSuccess
        });
      }
    }
  }, {
    key: "trackEventCollector",
    value: function trackEventCollector(name) {
      var _this$props2 = this.props,
          currentPlanId = _this$props2.currentPlanId,
          currentPlanCode = _this$props2.currentPlanCode,
          versionedBundleId = _this$props2.versionedBundleId;
      ec(name, {
        current_plan_id: currentPlanId,
        current_plan_code: currentPlanCode,
        modal_type: 'web_confirmation_modal',
        pending_add_on_id: versionedBundleId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          purchaseError = _this$props3.purchaseError,
          bundleName = _this$props3.bundleName,
          strikeThroughPrice = _this$props3.strikeThroughPrice,
          strikeThroughPriceFractionalDigits = _this$props3.strikeThroughPriceFractionalDigits,
          currencyCode = _this$props3.currencyCode,
          price = _this$props3.price,
          priceFractionalDigits = _this$props3.priceFractionalDigits,
          hasTax = _this$props3.hasTax,
          subscriptionCycleEndDate = _this$props3.subscriptionCycleEndDate,
          purchaseLoading = _this$props3.purchaseLoading;
      return React.createElement("div", {
        className: "modal__body"
      }, React.createElement(ApiError, {
        error: purchaseError,
        surfacedErrorCodes: [BUNDLE_PURCHASE_REQUEST_ERR_CODE, BUNDLE_PURCHASE_CARD_ERR_CODE]
      }), React.createElement("h2", {
        className: "mb"
      }, React.createElement(FormattedMessage, {
        id: "classBundles.modal.title",
        defaultMessage: "Review the details"
      })), React.createElement("p", null, React.createElement(FormattedMessage, {
        id: "classBundles.modal.credits.copy",
        defaultMessage: "Your credits will be added to your account immediately"
      })), React.createElement("div", {
        className: "mv p color-background-light"
      }, React.createElement("h3", null, React.createElement(FormattedMessage, {
        id: "classBundles.modal.bundleName",
        defaultMessage: "{name}",
        values: {
          name: bundleName
        }
      })), React.createElement("p", null, strikeThroughPrice && React.createElement("del", {
        className: "text--sm text--light"
      }, React.createElement(FormattedNumber, {
        value: strikeThroughPrice,
        style: "currency",
        minimumFractionDigits: strikeThroughPriceFractionalDigits,
        maximumFractionDigits: strikeThroughPriceFractionalDigits,
        currency: currencyCode
      })), "\xA0", React.createElement("span", {
        className: "text--lg"
      }, React.createElement(FormattedNumber, {
        value: price,
        style: "currency",
        minimumFractionDigits: priceFractionalDigits,
        maximumFractionDigits: priceFractionalDigits,
        currency: currencyCode
      })), hasTax && React.createElement(FormattedMessage, {
        id: "classBundles.modal.applicableTax",
        defaultMessage: " + tax"
      })), React.createElement("p", {
        className: "mh text--sm text--light"
      }, React.createElement(FormattedMessage, {
        id: "classBundles.modal.credits.disclaimers",
        defaultMessage: "Your month resets on {expirationDate}, at which point up to 10 credits will automatically roll over.{br}Credit purchases are a one-time charge and non-refundable.",
        values: {
          br: React.createElement("br", null),
          expirationDate: React.createElement(FormattedDate, {
            value: subscriptionCycleEndDate,
            year: "numeric",
            month: "long",
            day: "2-digit",
            timeZone: "utc"
          })
        }
      }))), React.createElement("button", {
        disabled: purchaseLoading,
        onClick: this.handleClick,
        className: classNames('bt bt--primary bt--lg block sm-inline-block 1/1 sm-auto', {
          'btn--waiting': purchaseLoading
        })
      }, React.createElement(FormattedMessage, {
        id: "classBundles.modal.cta",
        defaultMessage: "Confirm purchase"
      })));
    }
  }]);

  return ClassBundleModalUnwrapped;
}(React.Component);
ClassBundleModalUnwrapped.propTypes = {
  purchaseError: PropTypes.object,
  purchaseLoading: PropTypes.bool,
  versionedBundleId: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  priceFractionalDigits: PropTypes.number.isRequired,
  strikeThroughPrice: PropTypes.number,
  strikeThroughPriceFractionalDigits: PropTypes.number.isRequired,
  hasTax: PropTypes.bool.isRequired,
  subscriptionCycleEndDate: PropTypes.string.isRequired,
  purchaseAddOn: PropTypes.func.isRequired,
  currentPlanId: PropTypes.number.isRequired,
  currentPlanCode: PropTypes.string.isRequired,
  bundleName: PropTypes.string.isRequired
};
export var ClassBundleModal = modal()(connect(mapStateToProps, mapDispatchToProps)(ClassBundleModalUnwrapped));